module.exports = __webpack_public_path__ + "img/logo-black-white.3a439316.svg";